import { BWI, ET, PT, UT, VT } from "./disciplines";
import { ConfirmationDialog } from "@/components/dialogs";
import { InspectorContext } from "../reducer";
import { PageButton, PageControls } from "../../../common/PageControls";
import { useContext } from "react";
import { useGetInspections, useSave } from "../queries";
import { useModalDialog } from "@/hooks";

export function MainInterface() {
  const { state } = useContext(InspectorContext);
  const { isLoading } = useGetInspections(
    state.discipline,
    state.welds.map((x) => x.weldId)
  );

  const save = useSave();
  const modal = useModalDialog();

  if (isLoading) {
    return <p>Loading welds...</p>;
  }

  function handleSave(redirect: boolean) {
    save.mutate({ inspections: state.inspections, redirect: redirect });
  }

  function handleSaveAndFinish() {
    if (state.inspections.some((x) => x.accept === false && x.defects.length === 0)) {
      modal.show(ConfirmationDialog, {
        caption: "Enter Defects",
        message: "Please enter defects for all rejected welds.",
      });
    } else {
      modal.show(ConfirmationDialog, {
        caption: "Save Changes",
        message: "Are you sure you want to save changes and finish?",
        onAccept: () => handleSave(true),
      });
    }
  }

  return (
    <>
      <div className="table-responsive">
        <table className="table table-hover text-center text-nowrap">
          {state.discipline === "BWI" && <BWI />}
          {state.discipline.endsWith("VT") && <VT />}
          {state.discipline.endsWith("PT") && <PT />}
          {state.discipline.endsWith("UT") && <UT />}
          {state.discipline.endsWith("ET") && <ET />}
        </table>
      </div>

      <PageControls showBack allowBack={!save.isLoading}>
        <PageButton onClick={() => handleSave(false)} loading={save.isLoading}>
          Save
        </PageButton>
        <PageButton onClick={handleSaveAndFinish} loading={save.isLoading}>
          Save and Finish
        </PageButton>
      </PageControls>
    </>
  );
}
